export const isSavingSeatedPatientTransport = (state) => state.isSavingSeatedPatientTransport;
